var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (!_vm.loading)?_c('main',{staticClass:"single"},[_c('Wrapper',{attrs:{"size":"xl","boxed":""}},[_c('Grid',{staticClass:"product__grid"},[_c('Column',{attrs:{"size":{
          default: '12',
          m: '7',
        }}},[_c('div',[_c('Media',{ref:"product-gallery",staticClass:"product__gallery",attrs:{"data":{
              type: 'gallery',
              gallery: _vm.productGallery,
              ratio: false,
              lazyload: false,
              object_fit: 'cover',
            }}})],1)]),_c('Column',{attrs:{"size":{
          default: '12',

          m: '5',
        }}},[_c('div',{staticClass:"single__ctas"},[_c('div',{staticClass:"single__top"},[_c('div',[_c('Title',{staticClass:"single__title",attrs:{"data":{
                  value: _vm.post.name,
                  size: 'xm',
                }}})],1),_c('Spacer',{attrs:{"bottom":"m"}},[_c('Flex',[(_vm.product)?_c('Price',{attrs:{"product":_vm.product}}):_vm._e(),_c('Availability',{attrs:{"product":_vm.product}})],1)],1),_c('Richtext',{staticClass:"single__description",attrs:{"data":{
                value: _vm.product.description
                  ? _vm.product.description
                  : _vm.post.description,
              }}})],1),_c('div',{staticClass:"product__selectors"},[(_vm.hasVariations)?_c('div',{staticClass:"product__variation-selector--wrapper"},_vm._l((_vm.attributes),function(attribute,index){return _c('div',{key:index},[_c('Flex',{attrs:{"justify":"center"}},[_c('Select',{staticClass:"product__variation-selector",attrs:{"data":_vm.getAttribute(attribute),"model":attribute.model,"has-errors":false},on:{"update:model":function($event){return _vm.$set(attribute, "model", $event)}},model:{value:(attribute.model),callback:function ($$v) {_vm.$set(attribute, "model", $$v)},expression:"attribute.model"}})],1)],1)}),0):_vm._e(),_c('Number',{attrs:{"data":{
                id: "number",
                fn: _vm.numberChanged,
                itemKey: _vm.product.id,
                readonly: _vm.cartLoading || _vm.isOos,
              },"value":_vm.numberToBeAdded},on:{"update:value":function($event){_vm.numberToBeAdded=$event}}})],1),_c('Cta',{staticClass:"single--button",attrs:{"data":{
              title: _vm.labelCart,
              url: false,
              fn: _vm.addToCart,
            },"disabled":!_vm.addableToCart,"theme":"button"}})],1)])],1)],1)],1):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }